/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Injectable } from '@angular/core';

import { NzTreeBaseService } from 'ng-zorro-antd/core/tree';

@Injectable()
export class NzTreeSelectService extends NzTreeBaseService {}
